import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d35b36d6")

_pushScopeId("data-v-d35b36d6")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header card-p border-0" }
const _hoisted_5 = { class: "card-title align-items-start flex-column" }
const _hoisted_6 = { class: "card-label fw-bolder fs-3" }
const _hoisted_7 = { class: "card-body p-0" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_10 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_11 = { class: "menu-item-wrapper" }
const _hoisted_12 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_14 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(`${_ctx.$t('message.CUSTOMER')} ${_ctx.$t('message.ADDRESSES')}`), 1)
          ])
        ]),
        _createVNode(_component_Search, {
          filter: false,
          showExport: false,
          clearInput: true,
          filterPlaceholder: 'message.SELECT',
          inputPlaceholder: "message.ENTER_KEY_TO_SEARCH_ADDRESS",
          onSearch: _ctx.searchHandler,
          onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAddresses(1, _ctx.uuid)))
        }, null, 8, ["filterPlaceholder", "onSearch"]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Table, {
              loading: _ctx.loader,
              module: "CustomerDetail",
              columns: _ctx.columns,
              rows: _ctx.addresses,
              padding: 5,
              pagination: _ctx.pagination,
              onHandleCurrentChange: _ctx.handleCurrentChange
            }, {
              "cell-company": _withId(({row:item}) => [
                _createTextVNode(_toDisplayString(item?.company ? item?.company : 'N/A'), 1)
              ]),
              "cell-country": _withId(({row:item}) => [
                _createTextVNode(_toDisplayString(item?.country ? item?.country?.name : 'N/A'), 1)
              ]),
              "cell-actions": _withId(({row:item}) => [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    (_ctx.$can('edit_address'))
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          _createVNode("a", {
                            onClick: ($event: any) => (_ctx.handleEdit(item)),
                            class: "menu-link me-1"
                          }, [
                            _hoisted_13,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                          ], 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.$can('delete_address'))
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode("a", {
                            onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                            class: "menu-link me-1"
                          }, [
                            _hoisted_15,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                          ], 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange"])
          ])
        ])
      ])
    ])
  ]))
})